import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { toRefs } from 'vue';
import { Account, AccountPresenter } from '@/models';


export default /*#__PURE__*/_defineComponent({
  props: {
    account: null,
    presenter: null,
    json: null
  },
  setup(__props: any) {

const props = __props as {
  account: Account,
  presenter: AccountPresenter,
  json: unknown,
}



const { json } = toRefs(props);

return (_ctx: any,_cache: any) => {
  const _component_json_explorer = _resolveComponent("json-explorer")!

  return (_openBlock(), _createBlock(_component_json_explorer, { json: _unref(json) }, null, 8, ["json"]))
}
}

})